import type { SVGProps } from "react";
const SvgCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="url(#check_svg__a)"
      d="M12 2.854a9.147 9.147 0 1 0 .001 18.293 9.147 9.147 0 0 0 0-18.293"
    />
    <path
      fill="#fff"
      d="m15.423 9.043-4.316 4.316-2.529-2.53a.753.753 0 1 0-1.065 1.067l3.061 3.061a.75.75 0 0 0 1.066 0l4.848-4.849a.754.754 0 0 0-1.065-1.065"
    />
    <defs>
      <linearGradient
        id="check_svg__a"
        x1={5.533}
        x2={18.467}
        y1={5.533}
        y2={18.467}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#61d18d" />
        <stop offset={1} stopColor="#4ea974" />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgCheck;
